module.exports = __webpack_public_path__ + "static/media/silhouette.678a0483.jpg";